import React from 'react';
import { useTranslations } from 'next-intl';

const Footer: React.FC = () => {
  const t = useTranslations('Footer');
  return (
    <footer className="text-foreground pb-6">
      <div className="container mx-auto px-4">
        <div className=" mt-6 pt-4 text-center">
          <p className="text-xs text-muted-foreground">
            {t('copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
